module.exports = "/work-site/img/history.21ad51ab.png";